// extracted by mini-css-extract-plugin
export var gone = "RemoteSite-module--gone--c80c7";
export var goneFoot = "RemoteSite-module--goneFoot--d8eed";
export var goneText = "RemoteSite-module--goneText--14ce5";
export var goneTitle = "RemoteSite-module--goneTitle--f0928";
export var spin = "RemoteSite-module--spin--bca7c";
export var spinner = "RemoteSite-module--spinner--1c39a";
export var wait = "RemoteSite-module--wait--c695a";
export var waitText = "RemoteSite-module--waitText--d1b3f";